// Bulk API URLs (used in Geo Segmentation flow)
export const PCMS_AMDSM_API_URL='/pcms-bulk-process-jobs/pcms-amd';
export const PCMS_SOT_API_URL='/pcms-bulk-process-jobs/pcms-sot';
export const PCMS_DETAILS_API_URL='/pcms-bulk-process-jobs/pcms-metrics?requestType=';

// Core API URLs (used in normal flow)
export const PCMS_AMDSM_CORE_API_URL='pcms-amd/';
export const PCMS_SOT_CORE_API_URL='pcms-sot/';
export const PCMS_DETAILS_CORE_API_URL='pcms-metrics/?requestType=';

export const PCMS_CARE_ASSIST_API_URL='care-assists-active-tins/';
export const PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_API_URL='care-assists-tin-activations-details/';
export const PCMS_FILTER_API_URL='standard-search/topfilter';
export const PCMS_FILTER_BULK_API_URL='/pcms-bulk-process/standard-search/topfilter';
